import {EnsAlertStatus, EnsRecipientStatus} from "../../../store/features/ens/types";

type EnsStatusKind = EnsAlertStatus | EnsRecipientStatus;

const STYLE: Record<EnsStatusKind, string> = {
    PENDING: 'border-warning-line bg-warning-tint text-warning-ink',
    ESCALATING: 'border-brand-tint bg-brand-tint text-brand-ink',
    CONFIRMED: 'border-success-tint bg-success-tint text-success-ink',
    FAILED: 'border-danger-tint bg-danger-tint text-danger-ink',
    CANCELLED: 'border-line bg-surface-muted text-ink-secondary',
    SKIPPED: 'border-line bg-surface-muted text-ink-secondary',
};

const DOT_COLOR: Record<EnsStatusKind, string> = {
    PENDING: 'bg-warning',
    ESCALATING: 'bg-brand',
    CONFIRMED: 'bg-success',
    FAILED: 'bg-danger',
    CANCELLED: 'bg-ink-disabled',
    SKIPPED: 'bg-ink-disabled',
};

const LABEL: Record<EnsStatusKind, string> = {
    PENDING: 'Pending',
    ESCALATING: 'Escalating',
    CONFIRMED: 'Confirmed',
    FAILED: 'Failed',
    CANCELLED: 'Cancelled',
    SKIPPED: 'Skipped',
};

interface Props {
    status: EnsStatusKind;
    size?: 'sm' | 'md' | 'lg';
    variant?: 'pill' | 'dot';
    className?: string;
}

const SIZE: Record<NonNullable<Props['size']>, string> = {
    sm: 'h-5 px-2 text-[11px]',
    md: 'h-7 px-3 text-xs',
    lg: 'h-8 px-3 text-sm',
};

export const StatusBadge = ({status, size = 'sm', variant = 'pill', className = ''}: Props) => {
    if (variant === 'dot') {
        return (
            <span
                className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border border-line bg-surface px-2 h-5 text-[11px] font-medium text-ink-secondary whitespace-nowrap ${className}`}
            >
                <span className={`h-1.5 w-1.5 rounded-full ${DOT_COLOR[status]}`}/>
                {LABEL[status]}
            </span>
        );
    }
    return (
        <span
            className={`inline-flex shrink-0 items-center justify-center rounded border font-semibold leading-none whitespace-nowrap ${STYLE[status]} ${SIZE[size]} ${className}`}
        >
            {LABEL[status]}
        </span>
    );
};
